export default "__VITE_ASSET__CIN9kvgy__"